import { useState } from "react";
import classNames from "classnames";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Lazy, Zoom } from "swiper/modules";
import { FiChevronLeft, FiChevronRight, FiX } from "react-icons/fi";
import "swiper/css";
import Image from "next/image";

interface ImageViewerProps {
  images: any[];
  initialIndex: number;
  onClose: () => void;
}

export const ImageViewer = ({
  images,
  initialIndex,
  onClose,
}: ImageViewerProps) => {
  const [activeIndex, setActiveIndex] = useState<number>(initialIndex);

  const renderPrevNextNav = () => {
    if (images?.length > 1) {
      const genericClass =
        "absolute top-1/2 transform -translate-y-1/2 w-8 h-8 bg-dark-gray bg-opacity-50 flex items-center justify-center rounded-full cursor-pointer transition-opacity z-30";
      return (
        <>
          <div
            id="prevNav"
            className={classNames(genericClass, "left-2", {
              "opacity-0": activeIndex === 0,
            })}
          >
            <FiChevronLeft size={24} className="text-white" />
          </div>
          <div
            id="nextNav"
            className={classNames(genericClass, "right-2", {
              "opacity-0": activeIndex === images?.length - 1,
            })}
          >
            <FiChevronRight size={24} className="text-white" />
          </div>
        </>
      );
    }

    return null;
  };
  return (
    <div className="fixed inset-0 overflow-hidden mx-auto w-full sm:max-w-screen-mobile h-screen z-30">
      <div className="absolute inset-0 bg-black" onClick={onClose} />
      <FiX
        className="absolute top-3 right-3 text-white cursor-pointer"
        onClick={onClose}
        size={24}
      />
      <Swiper
        modules={[Navigation, Lazy, Zoom]}
        slidesPerView={1}
        className="relative w-full bg-black top-1/2 transform -translate-y-1/2"
        style={{ maxWidth: 480 }}
        navigation={{
          prevEl: "#prevNav",
          nextEl: "#nextNav",
        }}
        zoom
        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
        initialSlide={activeIndex}
      >
        {!!images?.length &&
          images.map((image, index) => (
            <SwiperSlide key={index}>
              <div className="swiper-zoom-container">
                <div className="relative pb-full overflow-hidden swiper-zoom-target">
                  <Image
                    src={image.imageUrl}
                    alt={image.alt}
                    layout="fill"
                    className="absolute inset-0 size-full object-cover"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        {renderPrevNextNav()}
      </Swiper>
    </div>
  );
};
